// <s-stone-video> — round looping video with a pause/play button.
// Pauses itself for reduced-motion shoppers and while scrolled out of view.
class SStoneVideo extends HTMLElement {
  #ac = null;
  #io = null;
  #userPaused = false;

  connectedCallback() {
    const video = this.querySelector('video');
    const button = this.querySelector('[data-stone-toggle]');
    if (!video) return;
    this.#ac = new AbortController();
    const signal = this.#ac.signal;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.#userPaused = true;
      video.pause();
      video.removeAttribute('autoplay');
      this.#sync(button, true);
    }

    button?.addEventListener('click', () => {
      this.#userPaused = !video.paused ? true : false;
      if (video.paused) video.play().catch(() => {});
      else video.pause();
      this.#sync(button, this.#userPaused);
    }, { signal });

    this.#io = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && !this.#userPaused) video.play().catch(() => {});
        else if (!entry.isIntersecting) video.pause();
      }
    }, { threshold: 0.2 });
    this.#io.observe(this);
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#io?.disconnect();
  }

  #sync(button, paused) {
    if (!button) return;
    button.setAttribute('aria-pressed', String(paused));
    button.setAttribute('aria-label', paused ? button.dataset.labelPlay : button.dataset.labelPause);
    button.querySelector('[data-icon-pause]')?.classList.toggle('hidden', paused);
    button.querySelector('[data-icon-play]')?.classList.toggle('hidden', !paused);
  }
}

if (!customElements.get('s-stone-video')) customElements.define('s-stone-video', SStoneVideo);
